import { isRouteErrorResponse, Navigate, useNavigate, useRouteError } from 'react-router'
import Alert, { AlertProps } from '../ui/Alert'
import Button, { LinkButton } from '../ui/Button'
import './ErrorPage.css'
import api from '../api'
import { useTranslation } from 'react-i18next'

const ErrorAlert = (props: AlertProps) => {
    return <section className="error-page">
        <Alert {...props} />
    </section>
}

export default function ErrorPage({ status = 500 }: { status?: number }) {
    const error = useRouteError() as any
    const navigate = useNavigate()
    const { t } = useTranslation()

    console.error(error)

    let message = ''
    if (isRouteErrorResponse(error)) {
        status = error.status
        message = error.data + ''
    }
    if (error?.response) {
        status = error.response.status
        message = error.response.data + ''
    }

    if (status === 401) {
        // in case the data router didn't catch this already
        return (
            <Navigate to="/login" />
        )
    }

    if (status === 403) {
        return (
            <AccessDenied />
        )
    }

    if (status === 404) {
        return (
            <ErrorAlert
                variant="plain"
                title={t('error_page_lost_title')}
                actions={
                    <>
                        <LinkButton to="/organization/projects">{t('go_to_projects')}</LinkButton>&nbsp;
                        <Button variant="secondary" onClick={async () => { await navigate(-1) }}>
                            {t('go_back')}
                        </Button>
                    </>
                }
            >{t('error_page_lost_desc')}</ErrorAlert>
        )
    }

    return (
        <ErrorAlert variant="error" title={`Error [${status.toString()}]`}>
            {message}
        </ErrorAlert>
    )
}

export function AccessDenied() {
    const { t } = useTranslation()
    const handleLogout = async () => {
        await api.auth.logout()
    }

    return (
        <ErrorAlert
            variant="plain"
            title={t('access_denied')}
            actions={
                <>
                    <LinkButton to="/organization/projects">{t('go_to_projects')}</LinkButton>&nbsp;
                    <Button variant="secondary" onClick={handleLogout}>{t('sign_out')}</Button>
                </>
            }
        >
            {t('access_denied_desc')}
        </ErrorAlert>
    )
}
